<template>
  <div class="wrapper">
    <div class="header">
      <span></span>
    </div>
    <v-chart
      :option="option"
      autoresize style="min-height: 500px; min-width: 500px;"
      @click="onClickPieChart"/>
  </div>
</template>

<script>
import moment from "moment";
import {use} from "echarts/core";
import {CanvasRenderer} from "echarts/renderers";
import {PieChart} from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import VChart from "vue-echarts";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  TimelineComponent
]);
import {mapGetters} from "vuex";
import {TimelineComponent} from 'echarts/components';

export default {
  name: "ResourceStatistics",
  components: {
    VChart,
  },
  props: {
    division_options: Object
  },
  computed: {
    ...mapGetters({
      resourceStatistics: "project/resourceStatistics",
    }),
    divisionOptions() {
      return this.division_options;
    }
  },
  watch: {
    'division_options': {
      handler: function (val, oldVal) {
        this.getData()
      }
    }
  },
  data() {
    return {
      statistics: [],
      option: {
        title: {
          text: 'Thống kê toàn công ty',
          bottom: 10,
          left: "center",
          textStyle: {
            color: '#303C54',
            fontWeight: 700,
            fontSize: 20,
            fontFamily: 'Helvetica',
          }
        },
        color: ['#01959E', '#EA6057'],
        tooltip: {
          trigger: 'item',
          textStyle: {
            fontFamily: 'Helvetica',
            fontSize: 16,
          }
        },
        legend: {
          top: '5%',
          left: 'center',
          itemHeight: 18,
          itemWidth: 18,
          textStyle: {
            color: '#303C54',
            fontWeight: 400,
            fontSize: 16,
            fontFamily: 'Helvetica',
          },
          align: "auto",
          data: ["Đang làm việc", "Đang rảnh"],
          itemGap: 30
        },
        series: [{
          data: [],
          type: "pie",
          radius: ['25%', '75%'],
          left: 'center',
          bottom: 0,
          label: {
            position: 'inside',
            minMargin: 5,
            color: '#FFFFFF',
            fontFamily: 'Helvetica',
            fontWeight: 700,
            fontSize: 20,
            formatter: '{c}%'
          },
        }]
      }
    };
  },
  async created() {
    await this.getData();
  },
  methods: {
    async getData() {
      try {
        await this.$store.dispatch("project/getResourceStatistics", {code: this.divisionOptions.value});
        this.option.title.text = this.divisionOptions.text;
        this.option.series[0].data = this.resourceStatistics.map(record => {
          return {
            name: record.name,
            value: record.value,
            label: {
              show: true,
            },
            status: record.status,
            divisions: this.$props.division_options
          };
        });
      } catch (error) {
        console.log(error)
      }
    },
    onClickPieChart(e) {
      let data = {
        activeTab: "tab-list",
        query: {
          status: e.data.status,
          skill: 0,
          footCode: e.data.divisions.value === 'all' ? 0 : e.data.divisions.value,
          division: 0,
          info: '',
          startDate: moment().subtract(7, 'd').format('DD/MM/YYYY'),
          endDate: moment().format('DD/MM/YYYY'),
        }
      };
      this.$emit('on-click-pie-chart', data);
    }
  },
}
</script>

<style scoped>

</style>
